import { CommonModule } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { PageheaderComponent } from '../../../../Components/pageheader/pageheader.component';
import { IPageHeader } from '../../../../Components/pageheader/pageHeader.model';
import { BAC_ABOUT_DATA } from '../bac-about.data';
import { BaseComponent } from '../../../base.component';
import { ContactCardComponent } from '../../../../Components/contact-card/contact-card.component';
import { AutoUnsubscribe } from '../../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../../Services/schoolApi.service';
import { BAC_PAGES, DOMAIN_TYPE, SCHEMA_TYPE } from '../../../../constants';
import { IResponse } from '../../../../Models/response.model';
import { IList } from '../../../../Models/list.model';
import { ISchoolArticle } from '../../../../Models/schoolArticle.model';
import { Utils } from '../../../../utils';

@AutoUnsubscribe()
@Component({
  selector: 'app-bac-staff',
  standalone: true,
  imports: [
    PageheaderComponent,
    TranslateModule,
    CommonModule,
    ContactCardComponent,
  ],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './bac-staff.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BacStaffComponent extends BaseComponent {
  public pageOptions: IPageHeader = {
    mainPage: { title: 'about_us', path: '/about' },
    children: [{ title: 'staff', path: null }],
  };

  public YEAR_PHOTO = BAC_ABOUT_DATA.staff.yearPhoto;
  public STAFF_DETAILS: any;
  public start: number = 0;
  public limit: number = 2;
  public totalcount: number;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef,
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.BAC;
    this.schemaType = SCHEMA_TYPE.MEDIA;
    this.articleType = BAC_PAGES.ABOUT.PERSONAL.STAFF;
  }

  ngOnInit(): void {
    this.onPaginateEvent(0);
  }

  onPaginateEvent($event: number) {
    this.start = $event;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.start,
        limit: this.limit,
        sortOrder: 1,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.totalcount = data.payload?.count || 0;
          this.STAFF_DETAILS = data.payload?.list.map((staff) => {
            return {
              image: Utils.mapBase64Image(staff.attachments[0].content),
              name: staff.title[this.language],
              job: staff.description[this.language],
            };
          });
          this.cdr.detectChanges();
        }
      });
  }
}
